module.exports = __webpack_public_path__ + "img/timeIco.311a6bd2.svg";